import { Caption, Flex, Icons, TicketDetails, Title } from '@tabeo/scarf'
import PropTypes from 'prop-types'
import React from 'react'
import getEmojiFromCountry from 'utils/getEmojiFromCountry'

const { Id, State } = TicketDetails

function States({ ticket, ...rest }) {
  const { countryCodes } = ticket

  return (
    <Flex justifyContent="flex-start" flexWrap="wrap" {...rest}>
      <State mb={2}>
        <Id color="primary.3">{ticket.id}</Id>
      </State>
      {ticket.isOverdue && (
        <State mb={2}>
          <Icons.Calendar fill="red.3" mr={1} />
          <Caption color="red.3">{ticket.overdueAtHumanized}</Caption>
        </State>
      )}
      {ticket.isStarred && (
        <State mb={2}>
          <Icons.Star active fill="yellow.3" mr={1} />
          <Caption color="yellow.2">Starred</Caption>
        </State>
      )}
      {ticket.isResolved && (
        <State mb={2} data-testid="ticket-resolved">
          <Icons.MarkAsDone fill="ink.2" mr={1} />
          <Caption color="ink.2">Resolved</Caption>
        </State>
      )}
      {countryCodes?.map(countryCode => (
        <State key={countryCode} mb={2}>
          <Title>{getEmojiFromCountry(countryCode)}</Title>
        </State>
      ))}
    </Flex>
  )
}

States.propTypes = {
  ticket: PropTypes.object.isRequired,
}

export default States
